<nz-layout>
  <nz-content>
    <div class="inner-content" style="height:90vh; display: flex; align-items: center;">
      <div style="width: 90vw; margin-bottom: 200px;">
        <div id="header-content" style="width: 90vw;">
          <h1>Protein Query</h1>
        </div>
        <div nz-row>
          <div nz-col nzSpan="4"></div>
          <div nz-col nzSpan="16">
            <nz-input-group nzSearch nzSize="large" [nzAddOnBefore]="propertySelect" [nzAddOnAfter]="suffixButton" nzCompact>
              <input type="text" nz-input placeholder="input search text" [(ngModel)]="searchValue" />
            </nz-input-group>
            <ng-template #propertySelect>
              <nz-select [(ngModel)]="selectedProperty">
                <nz-option nzLabel="name" nzValue="name"></nz-option>
                <nz-option nzLabel="accession" nzValue="accession"></nz-option>
                <nz-option nzLabel="sequence" nzValue="sequence"></nz-option>
                <nz-option nzLabel="keyword" nzValue="keyword"></nz-option>
                <nz-option *ngIf="false" nzLabel="specie" nzValue="specie"></nz-option>
              </nz-select>
            </ng-template>
            <ng-template #suffixButton>
              <button nz-button nzType="primary" nzSize="large" nzSearch [routerLink]="['/protein_search_result', selectedProperty, searchValue, '0']">Search</button>
            </ng-template>
            <p *ngIf="selectedProperty == 'name'">Please input the name of the protein you want to search. For example, <span class="green-font" (click)="searchValue='P53_HUMAN'">P53_HUMAN</span>、<span class="green-font" (click)="searchValue='MDM2_HUMAN'">MDM2_HUMAN</span>.</p>
            <p *ngIf="selectedProperty == 'accession'">Please input the accession of the protein you want to search. For example, <span class="green-font" (click)="searchValue='P04637'">P04637</span>、<span class="green-font" (click)="searchValue='A8K2S6'">A8K2S6</span>.</p>
            <p *ngIf="selectedProperty == 'sequence'">Please input the sequence of the protein you want to search. For example, <span class="green-font" (click)="searchValue='MEEPQSDPSVEPPLSQETFSDLWKLLPENNVLSPLPSQAMDDLMLSPDDIEQWFTEDPGP DEAPRMPEAAPPVAPAPAAPTPAAPAPAPSWPLSSSVPSQKTYQGSYGFRLGFLHSGTAK SVTCTYSPALNKMFCQLAKTCPVQLWVDSTPPPGTRVRAMAIYKQSQHMTEVVRRCPHHE RCSDSDGLAPPQHLIRVEGNLRVEYLDDRNTFRHSVVVPYEPPEVGSDCTTIHYNYMCNS SCMGGMNRRPILTIITLEDSSGNLLGRNSFEVRVCACPGRDRRTEEENLRKKGEPHHELP PGSTKRALPNNTSSSPQPKKKPLDGEYFTLQIRGRERFEMFRELNEALELKDAQAGKEPG GSRAHSSHLKSKKGQSTSRHKKLMFKTEGPDSD'">MEEPQSDPSVEPPLSQETFSDLWKLLPENNVLSPLPSQAMDDLMLSPDDIEQWFTEDPGP DEAPRMPEAAPPVAPAPAAPTPAAPAPAPSWPLSSSVPSQKTYQGSYGFRLGFLHSGTAK SVTCTYSPALNKMFCQLAKTCPVQLWVDSTPPPGTRVRAMAIYKQSQHMTEVVRRCPHHE RCSDSDGLAPPQHLIRVEGNLRVEYLDDRNTFRHSVVVPYEPPEVGSDCTTIHYNYMCNS SCMGGMNRRPILTIITLEDSSGNLLGRNSFEVRVCACPGRDRRTEEENLRKKGEPHHELP PGSTKRALPNNTSSSPQPKKKPLDGEYFTLQIRGRERFEMFRELNEALELKDAQAGKEPG GSRAHSSHLKSKKGQSTSRHKKLMFKTEGPDSD</span>.</p>
            <p *ngIf="selectedProperty == 'keyword'">Please input the keyword of the protein you want to search. For example, <span class="green-font" (click)="searchValue='DNA-binding'">DNA-binding</span>、<span class="green-font" (click)="searchValue='Disease mutation'">Disease mutation</span>.</p>
          </div>
          <div nz-col nzSpan="4"></div>
        </div>
      </div>
<!--    
      <nz-divider></nz-divider>


      <div nz-row>
        <div nz-col nzSpan="2"></div>
        <div nz-col nzSpan="6">
          <h3 [ngStyle]="{ margin: '16px 0' }">Top Degree of &nbsp;
            <nz-select [(ngModel)]="selectedProperty">
            <nz-option nzLabel="HUMAN" nzValue="name"></nz-option>
            <nz-option nzLabel="MOUSE" nzValue="accession"></nz-option>
            <nz-option nzLabel="RAT" nzValue="sequence"></nz-option>
          </nz-select>
        </h3>
          <ul nz-list nzBordered nzSize="small">
            <li nz-list-item *ngFor="let item of data.TopDegree">
              {{ item.name }}
              <nz-tag [nzColor]="'#87d068'">{{ item.date }}</nz-tag>
            </li>
          </ul>
        </div>
        <div nz-col nzSpan="1"></div>
        <div nz-col nzSpan="6">
          <h3 [ngStyle]="{ margin: '16px 0 23px 0' }">Top Reference Count</h3>
          <ul nz-list nzBordered nzSize="small">
            <li nz-list-item *ngFor="let item of data.TopReferenceCount">
              {{ item.name }}
              <nz-tag [nzColor]="'#87d068'">{{ item.count }}</nz-tag>
            </li>
          </ul>
        </div>
        <div nz-col nzSpan="1"></div>
        <div nz-col nzSpan="6">
          <h3 [ngStyle]="{ margin: '16px 0 23px 0' }">Up To Date</h3>
          <ul nz-list nzBordered nzSize="small">
            <li nz-list-item *ngFor="let item of data.up2date">
              {{ item.name }}
              <nz-tag [nzColor]="'#87d068'">{{ item.count }}</nz-tag>
            </li>
          </ul>
        </div>
        <div nz-col nzSpan="2"></div>
      </div>
-->


    </div>
  </nz-content>
</nz-layout>
